export default __webpack_public_path__ + "static/media/thank-goodness-for-you.e38977ed.webp";